import { PACKAGES } from '@/lib/packages';
import { WA_MESSAGES } from '@/lib/whatsapp';
import { HOME } from '@/constants/testIds';
import { PackageCard } from '@/components/home/PackageCard';
import { PackageScope } from '@/components/home/PackageScope';
import { PackageUpgradeNote } from '@/components/home/PackageUpgradeNote';
import { SectionHeading } from '@/components/home/SectionHeading';
import { WhatsAppCta } from '@/components/home/WhatsAppCta';

export const Pricing = () => (
  <section id="pakej" data-testid={HOME.pricingSection} className="gg-section gg-pricing">
    <div className="gg-container">
      <div className="gg-heading-row">
        <SectionHeading id="pricing" eyebrow="BANDINGKAN PAKEJ HIKVISION" title="Berapa sudut rumah anda mahu pantau?">4, 8 atau 16 kamera. Semua pakej termasuk pemasangan dan setup app telefon.</SectionHeading>
        <p className="gg-payment-note" data-testid="pricing-payment-terms"><strong>Bayaran sekali, bukan sewaan.</strong><span>50% deposit. Baki 50% selepas handover.</span></p>
      </div>
      <div className="gg-package-help">
        <p data-testid="pricing-help-copy"><strong>Tak pasti pakej mana?</strong><span>Hantar lokasi dan jenis rumah. Kami bantu semak.</span></p>
        <WhatsAppCta testId="pricing-custom-quote-whatsapp" message={WA_MESSAGES.general}>WhatsApp Semak Pakej</WhatsAppCta>
      </div>
      <div className="gg-package-grid">{PACKAGES.map(tier => <PackageCard key={tier.id} tier={tier} />)}</div>
      <PackageUpgradeNote />
      <PackageScope />
    </div>
  </section>
);

export default Pricing;